import type {org} from "boislocal-platform-platform-api-api-js-export";
import {ProductModel, ProductSection} from "./product";

export type ProductEvidenceUploadCommand = org.boislocal.platform.f2.product.evidence.domain.command.ProductEvidenceUploadCommandDTO
export type ProductEvidenceUploadedEvent = org.boislocal.platform.f2.product.evidence.domain.command.ProductEvidenceUploadedEventDTO

export type ProductEvidenceDeleteCommand = org.boislocal.platform.f2.product.evidence.domain.command.ProductEvidenceDeleteCommandDTO
export type ProductEvidenceDeletedEvent = org.boislocal.platform.f2.product.evidence.domain.command.ProductEvidenceDeletedEventDTO

export type ProductEvidenceListQuery = org.boislocal.platform.f2.product.evidence.domain.query.ProductEvidenceListQueryDTO
export type ProductEvidenceListResult = org.boislocal.platform.f2.product.evidence.domain.query.ProductEvidenceListResultDTO

export type ProductEvidenceFile = org.boislocal.platform.f2.product.evidence.domain.model.ProductEvidenceFileDTO
export type ProductEvidenceSection = org.boislocal.platform.f2.product.evidence.domain.model.ProductEvidenceSectionDTO

export const ProductEvidenceSectionValues: Record<string, ProductEvidenceSection> = {
  from: {value: "FROM"},
  to: {value: "TO"}
}
export const toProductEvidenceSection = (section: ProductSection): ProductEvidenceSection => {
  return ProductEvidenceSectionValues[section]
}

type AuthedUser = { roles: string[]; memberOf?: string }

function hasAllRoles(user: AuthedUser, roles: string[]): boolean {
  return roles.every(role => user.roles.includes(role))
}

function isTransformationActor(user: AuthedUser, product?: ProductModel): boolean {
  return product?.transformation?.actor?.id === user.memberOf && user.memberOf != null
}

function isMarqueOrTransformationActorOrAdmin(user: AuthedUser, product?: ProductModel): boolean {
  return hasAllRoles(user, ['Marque', 'admin']) || isTransformationActor(user, product)
}

function isTransformationActorOrAdmin(user: AuthedUser, product?: ProductModel): boolean {
  return hasAllRoles(user, ['admin']) || isTransformationActor(user, product)
}

export const ProduitEvidencePolicies = {
  canList: (authedUser: AuthedUser, product?: ProductModel): boolean =>
    isMarqueOrTransformationActorOrAdmin(authedUser, product),
  canDownload: (authedUser: AuthedUser, product?: ProductModel): boolean =>
    isMarqueOrTransformationActorOrAdmin(authedUser, product),
  canUpload: (authedUser: AuthedUser, product?: ProductModel): boolean =>
    isTransformationActorOrAdmin(authedUser, product),
  canDelete: (authedUser: AuthedUser, product?: ProductModel): boolean =>
    isTransformationActorOrAdmin(authedUser, product),
}

export type ProductEvidencePoliciesType = typeof ProduitEvidencePolicies

export interface ProduitEvidencePoliciesResult {
  canUpload: boolean
  canDelete: boolean
  canDownload: boolean
  canList: boolean
}
